import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    name: item.label,
    item: item.href ? `https://dongshengdawutai.com${item.href}` : undefined,
  }));

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script
        type="application/ld+json"
        data-seo-schema="true"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}